
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branded-boards",
      function () {
        return require("private-next-pages/branded-boards.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branded-boards"])
      });
    }
  